"use client";

import { EmptyWallet } from "iconsax-reactjs";
import { useTranslations } from "next-intl";
import type React from "react";
import { useEffect, useState } from "react";
import BrandLogo from "@/assets/logo.svg";
import { ConnectButton } from "@/components/core/ConnectButton";
import { Button } from "@/components/ui/button";
import { MenuIcon } from "@/components/ui/MenuIcon";
import { useSidebar } from "@/context/sidebar";
import { useWallet } from "@/context/wallet";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { Sidebar } from "../../features/landing/Sidebar/Sidebar";
import { TopNavLogin } from "./TopNavLogin";

export const TopNav: React.FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations("nav");
  const { isConnected, open } = useWallet();
  const sidebar = useSidebar();
  const [sidebarMounted, setSidebarMounted] = useState(false);
  useEffect(() => {
    if (sidebar.isOpen) setSidebarMounted(true);
  }, [sidebar.isOpen]);
  return (
    <>
      <nav
        aria-label={t("networkBrand")}
        className={cn(
          "relative z-10 flex items-center justify-between gap-3 border-b border-divider bg-background px-4 py-3",
          className,
        )}
      >
        <div className="flex min-w-0 items-center gap-3">
          <Button
            variant="light"
            size="icon"
            className="lg:hidden"
            aria-label={t("menu")}
            aria-expanded={sidebar.isOpen}
            onClick={() => sidebar.setIsOpen(true)}
          >
            <MenuIcon size={24} />
          </Button>
          <Link
            href="/"
            aria-label={t("networkBrand")}
            className="flex items-center gap-3 py-1 text-foreground"
          >
            <BrandLogo className="size-6 shrink-0" aria-label={t("home")} />
            <span className="text-sm font-semibold sm:text-base">
              {t("networkBrand")}
            </span>
          </Link>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <ConnectButton>{t("connect")}</ConnectButton>
          {isConnected && (
            <Button
              variant="light"
              size="icon"
              aria-label={t("connectWallet")}
              onClick={() => open()}
            >
              <EmptyWallet size={24} variant="Linear" />
            </Button>
          )}
          <TopNavLogin />
        </div>
      </nav>
      {sidebarMounted && <Sidebar />}
    </>
  );
};
